<template>
  <div class="container mt-3">
    <div class="mt-3">
      <h3 class="title mb-3">FAQ 관리</h3>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
